import { render, staticRenderFns } from "./PDP.vue?vue&type=template&id=42b32a8d&scoped=true"
import script from "./PDP.vue?vue&type=script&lang=js"
export * from "./PDP.vue?vue&type=script&lang=js"
import style0 from "./PDP.vue?vue&type=style&index=0&id=42b32a8d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b32a8d",
  null
  
)

export default component.exports